// @flow
export function getServiceOutage(serviceUrlBase: string, locale: string): Promise<*> {
    return fetch(`${serviceUrlBase}${locale}.json`);
}



// WEBPACK FOOTER //
// ./src/core/api/service-outage/service-outage.api.js